import type { ReactNode } from "react"

import StoreFooter from "@/components/patterns/StoreFooter"
import StoreHeader from "@/components/patterns/StoreHeader"

const StorefrontFrame = ({ children }: { children: ReactNode }) => (
  <>
    <StoreHeader />
    {children}
    <div className="relative mx-auto w-full max-w-[1440px] px-4 pb-6 sm:px-6 md:pb-8 xl:px-[30px]">
      <StoreFooter />
    </div>
  </>
)

export default StorefrontFrame
